<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { addRecentVisit } from "@/utils/micoapp-recent";
import { ADMIN_MICOAPP_API as MICOAPP_API, COMPONENT_API } from "@/config/social-api";
import { describeIcpEntrance } from "@/utils/icp-entrance-status";

/**
 * Starter page component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Starter page",
            items: [
                {
                    text: "Utility",
                    href: "/",
                },
                {
                    text: "Starter page",
                    active: true,
                },
            ],
            loading: false,
            refreshInfoLoading: false,
            qrcodeLoading: false,
            qrcodeDialogVisible: false,
            qrcodeDialogUrl: '',
            qrcodeDialogFallbackUrl: '',
            qrcodeLoadFailed: false,
            userinfo: [],
            micoapplist: {},
            versionStatus: null,
            versionStatusLoading: false,
            versionStatusLoaded: false,
            commitLoading: false,
            icpEntrance: null,
            icpEntranceLoading: false,
        };
    },
    computed: {
        isAuthOperator() {
            const u = this.userinfo;
            if (!u || u.id === undefined || u.id === null) return false;
            return Number(u.id) === 4;
        },
        /** iot_micoapp.version（id）< iot_micoapp_version.id 时可更新；commit 用 tempid→微信 template_id */
        versionNeedUpdate() {
            const s = this.versionStatus;
            if (!s || !s.has_latest) return false;
            return Number(s.current_version_id) < Number(s.latest_version_id);
        },
    },
    watch: {
        "$route.params.appid"(newId) {
            if (newId && newId !== this.appid) {
                this.appid = newId;
                this.getmicoappinfo();
            }
        },
    },
    mounted() {
        try {
            this.userinfo = JSON.parse(localStorage.getItem("user") || "null") || {};
        } catch (e) {
            this.userinfo = {};
        }
        this.title = this.$t("menuitems.icp.micoapp.info");
        this.items = [
            {
                text: this.$t("menuitems.micoapp.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.icp.micoapp.list"),
                href: "/micoapp",
            },
            {
                text: this.$t("menuitems.icp.micoapp.info"),
                active: true,
            },
        ];
        this.appid = this.$route.params.appid;
        this.getmicoappinfo();
    },
    methods: {
        getmicoappinfo() {
            var that = this;
            that.loading = true;
            that.$axios
                .post(
                    MICOAPP_API,
                    {
                        action: "micoapp.info",
                        appid: that.appid,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    that.micoapplist = response.data.data;
                    if (that.micoapplist && that.micoapplist.appid) {
                        addRecentVisit({
                            appid: that.micoapplist.appid,
                            niconame: that.micoapplist.niconame,
                            head_img: that.micoapplist.head_img,
                        });
                    }
                    that.fetchVersionStatus();
                    that.fetchIcpEntrance();
                })
                .catch(function (error) {
                    console.log(error);
                    that.loading = false;
                });
        },
        async fetchIcpEntrance() {
            if (!this.appid) return;
            this.icpEntranceLoading = true;
            try {
                const res = await this.$axios.post(
                    COMPONENT_API,
                    { action: "geticpstatus", appid: this.appid },
                    { headers: { Openid: this.userinfo.openid } }
                );
                this.icpEntrance = describeIcpEntrance(res.data);
            } catch (e) {
                console.error(e);
                this.icpEntrance = null;
            } finally {
                this.icpEntranceLoading = false;
            }
        },
        async fetchVersionStatus() {
            if (!this.appid) return;
            this.versionStatusLoading = true;
            try {
                const res = await this.$axios.post(
                    MICOAPP_API,
                    { action: "micoapp.versionStatus", appid: this.appid },
                    { headers: { Openid: this.userinfo.openid } }
                );
                const d = res.data && res.data.data;
                this.versionStatus = d && typeof d === "object" ? d : null;
            } catch (e) {
                console.error(e);
                this.versionStatus = null;
            } finally {
                this.versionStatusLoading = false;
                this.versionStatusLoaded = true;
            }
        },
        async commitToLatestVersion() {
            const s = this.versionStatus;
            if (!s || !s.has_latest || !this.versionNeedUpdate) return;
            const tid = s.tempid;
            if (tid === "" || tid === null || tid === undefined || Number(tid) === 0) {
                this.$message.warning("最新版本记录缺少 tempid（微信模板 id），无法提交");
                return;
            }
            this.commitLoading = true;
            try {
                const res = await this.$axios.post(COMPONENT_API, {
                    action: "commit",
                    appid: this.appid,
                    template_id: tid,
                    version: (s.version && String(s.version).trim()) || "1.0.0",
                    desc: (s.desc && String(s.desc).trim()) || "更新至最新模板版本",
                });
                const data = res.data;
                if (data && Number(data.errcode) === 0) {
                    this.$message.success("已调用上传代码（commit），小程序版本已同步为最新");
                    await this.fetchVersionStatus();
                    this.getmicoappinfo();
                } else {
                    this.$message.error(
                        (data && data.errmsg) || "微信接口返回失败"
                    );
                }
            } catch (e) {
                console.error(e);
                this.$message.error("commit 请求失败");
            } finally {
                this.commitLoading = false;
            }
        },
        async refreshAppidInfo() {
            const appid = this.appid || (this.micoapplist && this.micoapplist.appid);
            if (!appid) {
                this.$message.warning('暂无 AppID');
                return;
            }
            this.refreshInfoLoading = true;
            try {
                const res = await this.$axios.post(
                    COMPONENT_API,
                    {
                        action: 'getappidinfo',
                        appid: appid,
                    }
                );
                const data = res.data;
                if (data && data.status != null && Number(data.status) !== 200) {
                    this.$message({
                        message: data.msg || '同步授权信息未成功',
                        type: 'warning',
                    });
                }
            } catch (e) {
                console.error(e);
                this.$message.error('同步授权信息请求失败');
            } finally {
                this.refreshInfoLoading = false;
                this.getmicoappinfo();
            }
        },
        beforeAvatarUpload() {
            console.log('beforeAvatarUpload')
        },
        handleAvatarSuccess(res, file) {
            console.log('handleAvatarSuccess')
        },
        async showMicoappQrcode(qrcodelink) {
            if (!qrcodelink) return;
            this.qrcodeLoading = true;
            let displayUrl = qrcodelink;
            try {
                // 优先尝试后端代理（需后端实现 micoapp.proxyQrcode 接口），可绕过 CORS 与反盗链
                try {
                    const proxyRes = await this.$axios.post(
                        MICOAPP_API,
                        {
                            action: 'micoapp.proxyQrcode',
                            appid: this.appid,
                            url: qrcodelink,
                        },
                        {
                            headers: { Openid: this.userinfo.openid },
                            responseType: 'blob',
                            timeout: 15000,
                        }
                    );
                    const contentType = (proxyRes.headers || {})['content-type'] || '';
                    if (proxyRes.data && proxyRes.data.size > 0 && contentType.indexOf('image/') !== -1) {
                        displayUrl = await this.blobToBase64(proxyRes.data);
                    }
                } catch (e) {
                    // 后端未实现或失败
                }
                // 使用 img 直接加载（避免 fetch 触发的 CORS），referrerPolicy 规避反盗链
                this.qrcodeDialogUrl = displayUrl;
                this.qrcodeDialogFallbackUrl = qrcodelink;
                this.qrcodeLoadFailed = false;
                this.qrcodeDialogVisible = true;
            } catch (error) {
                console.error('加载失败:', error);
                this.$confirm('无法加载小程序码，是否在新标签页中打开？', '提示', {
                    confirmButtonText: '新标签页打开',
                    cancelButtonText: '取消',
                    type: 'info',
                }).then(() => {
                    window.open(qrcodelink, '_blank', 'noopener,noreferrer');
                }).catch(() => {});
            } finally {
                this.qrcodeLoading = false;
            }
        },
        onQrcodeImgError() {
            this.qrcodeLoadFailed = true;
        },
        openQrcodeInNewTab() {
            if (this.qrcodeDialogFallbackUrl) {
                window.open(this.qrcodeDialogFallbackUrl, '_blank', 'noopener,noreferrer');
            }
        },
        // Blob 转 Base64
        blobToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        routeto(path) {
            this.$router.push({ path: path });
        },
        formatTimestamp(val) {
            if (val === null || val === undefined || val === '' || val == 0) return '—';
            const num = Number(val);
            if (isNaN(num)) return '—';
            // 秒级时间戳(< 10位数)需乘1000，毫秒级直接使用
            const ms = num < 10000000000 ? num * 1000 : num;
            const date = new Date(ms);
            if (isNaN(date.getTime())) return '—';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
    },


};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-info-page">
            <div class="row" v-loading="loading">
                <!-- 概览卡片 -->
                <div class="col-12">
                    <div class="card micoapp-info-overview">
                        <div class="card-body">
                            <div class="micoapp-info-header">
                                <div class="micoapp-info-avatar-wrap">
                                    <img v-if="micoapplist.head_img" :src="micoapplist.head_img" class="micoapp-info-avatar" alt="">
                                    <div v-else class="micoapp-info-avatar-placeholder">{{ (micoapplist.niconame || '').charAt(0) }}</div>
                                </div>
                                <div class="micoapp-info-meta">
                                    <h4 class="micoapp-info-name">{{ micoapplist.niconame }}</h4>
                                    <div class="micoapp-info-appid">AppID: {{ micoapplist.appid }}</div>
                                    <div class="micoapp-info-badges">
                                        <el-tag v-if="micoapplist.realname == 0" type="danger" size="small">未认证</el-tag>
                                        <el-tag v-else-if="micoapplist.realname == 1" type="success" size="small">已认证</el-tag>
                                        <el-tag v-else-if="micoapplist.realname == 2" type="warning" size="small">认证中</el-tag>
                                        <el-tag v-else-if="micoapplist.realname == 3" type="info" size="small">认证失败</el-tag>
                                        <el-tag v-if="icpEntrance && icpEntrance.label" :type="icpEntrance.tone" size="small">{{ icpEntrance.label }}</el-tag>
                                        <el-tag v-else-if="micoapplist.icpstatus == 0" type="info" size="small">未备案</el-tag>
                                        <el-tag v-else-if="micoapplist.icpstatus == 1" type="success" size="small">已备案</el-tag>
                                        <el-tag v-else-if="micoapplist.icpstatus == 2" type="warning" size="small">备案审核中或未通过</el-tag>
                                    </div>
                                    <div v-if="micoapplist.appid" class="micoapp-info-version-row">
                                        <template v-if="versionStatusLoading">
                                            <span class="text-muted small">模板版本检测中…</span>
                                        </template>
                                        <template v-else-if="versionStatus && versionStatus.has_latest">
                                            <template v-if="versionNeedUpdate">
                                                <el-button
                                                    type="warning"
                                                    size="small"
                                                    plain
                                                    :loading="commitLoading"
                                                    @click="commitToLatestVersion"
                                                >
                                                    更新版本
                                                </el-button>
                                                <span class="text-muted small ml-2">可升级至模板最新版（版本号 {{ versionStatus.version || '—' }}）</span>
                                            </template>
                                            <template v-else>
                                                <span class="micoapp-version-ok"><i class="el-icon-success"></i> 当前是最新版</span>
                                            </template>
                                        </template>
                                        <template v-else-if="versionStatusLoaded && versionStatus && !versionStatus.has_latest">
                                            <span class="text-muted small">暂无模板版本数据</span>
                                        </template>
                                    </div>
                                </div>
                                <div class="micoapp-info-qrcode">
                                    <el-link
                                        type="primary"
                                        :loading="qrcodeLoading"
                                        @click.prevent="showMicoappQrcode(micoapplist.qrcode)"
                                    >
                                        查看小程序码 →
                                    </el-link>
                                    <el-button
                                        type="default"
                                        size="small"
                                        plain
                                        :loading="refreshInfoLoading"
                                        :disabled="!$route.params.appid"
                                        @click="refreshAppidInfo"
                                    >
                                        刷新信息
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 详情信息 -->
                <div class="col-lg-6">
                    <div class="card micoapp-info-card">
                        <div class="card-body">
                            <h6 class="micoapp-info-card-title">认证信息</h6>
                            <dl class="micoapp-info-dl">
                                <dt>认证过期时间</dt>
                                <dd>{{ formatTimestamp(micoapplist.endtime) }}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="card micoapp-info-card">
                        <div class="card-body">
                            <h6 class="micoapp-info-card-title">备案信息</h6>
                            <dl class="micoapp-info-dl">
                                <dt>备案状态</dt>
                                <dd v-if="icpEntranceLoading">查询中…</dd>
                                <dd v-else-if="icpEntrance && icpEntrance.label">
                                    <el-tag :type="icpEntrance.tone" size="small">{{ icpEntrance.label }}</el-tag>
                                    <span v-if="icpEntrance.canceling">，正在注销备案</span>
                                </dd>
                                <dd v-else>—</dd>
                                <template v-if="icpEntrance && icpEntrance.sms">
                                    <dt>管局短信核验</dt>
                                    <dd>{{ icpEntrance.sms }}</dd>
                                </template>
                                <template v-if="icpEntrance && icpEntrance.auditItems.length">
                                    <dt>驳回原因</dt>
                                    <dd>
                                        <div v-for="(item, index) in icpEntrance.auditItems" :key="'icp-audit-' + index">
                                            {{ item.keyName }}：{{ item.error }}
                                            <span v-if="item.suggest">。{{ item.suggest }}</span>
                                        </div>
                                    </dd>
                                </template>
                                <dt>备案号</dt>
                                <dd>{{ micoapplist.icpcode || '—' }}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
                <div id="micoapp-wechat-mgmt" class="col-12" v-if="micoapplist.appid">
                    <div class="card micoapp-info-card">
                        <div class="card-body">
                            <h6 class="micoapp-info-card-title">小程序管理</h6>
                            <div class="micoapp-info-actions">
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/basicinfo')">
                                    <i class="el-icon-document"></i>
                                    <span>基础信息</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/category')">
                                    <i class="el-icon-folder-opened"></i>
                                    <span>服务类目</span>
                                </div>
                                <div
                                    v-if="isAuthOperator"
                                    class="micoapp-info-action-item"
                                    @click="routeto('/micoapp/' + micoapplist.appid + '/auth')"
                                >
                                    <i class="el-icon-success"></i>
                                    <span>认证服务</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/icp')">
                                    <i class="el-icon-s-order"></i>
                                    <span>小程序备案</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/audit')">
                                    <i class="el-icon-s-check"></i>
                                    <span>审核管理</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/violations')">
                                    <i class="el-icon-warning-outline"></i>
                                    <span>违规与申诉</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/wechat/mp')">
                                    <i class="el-icon-link"></i>
                                    <span>公众号接入</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 快捷操作 -->
                <div class="col-12" v-if="micoapplist.appid">
                    <div class="card micoapp-info-card">
                        <div class="card-body">
                            <h6 class="micoapp-info-card-title">快捷操作</h6>
                            <div class="micoapp-info-actions">
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/menu')">
                                    <i class="el-icon-menu"></i>
                                    <span>菜单管理</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/charge')">
                                    <i class="el-icon-coin"></i>
                                    <span>充值管理</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/point')">
                                    <i class="el-icon-star-on"></i>
                                    <span>积分设置</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/register')">
                                    <i class="el-icon-user"></i>
                                    <span>注册设置</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/sale')">
                                    <i class="el-icon-goods"></i>
                                    <span>营销设置</span>
                                </div>
                                <div class="micoapp-info-action-item" @click="routeto('/micoapp/' + micoapplist.appid + '/home')">
                                    <i class="el-icon-picture-outline"></i>
                                    <span>首页设置</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 小程序码弹窗：使用 img 直接加载，避免 fetch 触发的 CORS -->
        <el-dialog
            title="小程序码"
            :visible.sync="qrcodeDialogVisible"
            width="320px"
            append-to-body
            :close-on-click-modal="true"
        >
            <div v-if="!qrcodeLoadFailed" class="micoapp-qrcode-wrap">
                <img
                    :src="qrcodeDialogUrl"
                    referrerpolicy="no-referrer"
                    alt="小程序码"
                    class="micoapp-qrcode-img"
                    @error="onQrcodeImgError"
                />
            </div>
            <div v-else class="micoapp-qrcode-fail">
                <p>图片加载失败（微信反盗链限制）</p>
                <el-button type="primary" size="small" @click="openQrcodeInNewTab">在新标签页打开</el-button>
            </div>
        </el-dialog>
    </Layout>
</template>

<style scoped>
.micoapp-info-overview {
  margin-bottom: 1.5rem;
}

.micoapp-info-header {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.micoapp-info-avatar-wrap {
  flex-shrink: 0;
}

.micoapp-info-avatar {
  width: 88px;
  height: 88px;
  border-radius: 20px;
  object-fit: cover;
  border: 2px solid #e5e7eb;
  background: #f8fafc;
}

.micoapp-info-avatar-placeholder {
  width: 88px;
  height: 88px;
  border-radius: 20px;
  background: linear-gradient(135deg, #e7f0ff 0%, #f0f4ff 100%);
  color: #2d6cdf;
  font-size: 2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.micoapp-info-meta {
  flex: 1;
  min-width: 180px;
}

.micoapp-info-name {
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0 0 0.35rem 0;
  color: #1f2937;
}

.micoapp-info-appid {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.75rem;
}

.micoapp-info-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.micoapp-info-version-row {
  margin-top: 0.75rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.5rem;
}

.micoapp-version-ok {
  font-size: 0.875rem;
  color: #16a34a;
  font-weight: 500;
}

.micoapp-version-ok i {
  margin-right: 0.25rem;
}

.micoapp-info-qrcode {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.micoapp-qrcode-wrap {
  text-align: center;
}

.micoapp-qrcode-img {
  max-width: 100%;
  width: 280px;
  height: auto;
}

.micoapp-qrcode-fail {
  text-align: center;
  padding: 1rem;
}

.micoapp-qrcode-fail p {
  color: #6b7280;
  margin: 0 0 1rem 0;
}

.micoapp-info-card {
  margin-bottom: 1.5rem;
}

.micoapp-info-card-title {
  font-weight: 600;
  color: #374151;
  margin: 0 0 1rem 0;
  font-size: 1rem;
}

.micoapp-info-dl {
  margin: 0;
}

.micoapp-info-dl dt {
  font-size: 0.8rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.micoapp-info-dl dd {
  margin: 0;
  font-size: 0.95rem;
  color: #1f2937;
}

.micoapp-info-actions {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.75rem;
}

.micoapp-info-action-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 1rem;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s ease;
}

.micoapp-info-action-item:hover {
  background: #e7f0ff;
  border-color: #2d6cdf;
  color: #2d6cdf;
}

.micoapp-info-action-item i {
  font-size: 1.25rem;
  color: #2d6cdf;
}

.micoapp-info-action-item:hover i {
  color: #2d6cdf;
}

.micoapp-info-action-item span {
  font-weight: 500;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .micoapp-info-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .micoapp-info-actions {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
